import { useMemo } from "react";
import { useAppSelector } from "store";
import { type AuthType, type AuthToken } from "utils/authUtils";

const useAuthToken = (tokenType: AuthType): AuthToken | undefined => {
  const { cognitoToken, hybridToken, proposalToken } =
    useAppSelector((state) => state.auth) || {};

  return useMemo(() => {
    switch (tokenType) {
      case "IHD":
        return cognitoToken?.token
          ? { type: "IHD", token: cognitoToken.token }
          : undefined;
      case "HYBRID":
        return hybridToken ? { type: "HYBRID", token: hybridToken } : undefined;
      case "PROPOSAL":
        return proposalToken
          ? { type: "PROPOSAL", token: proposalToken }
          : undefined;
    }
  }, [cognitoToken?.token, hybridToken, proposalToken, tokenType]);
};

export { useAuthToken };
